import React, { useState } from 'react'

import CLOSE_WHITE_ICON from '@public/assets/common/ai_close_white.svg'
import INFORMATION_WHITE_ICON from '@public/assets/information_white.svg'
import { cn } from '@utils/mergeClassNames'
import { AUDIT_LOG_GUIDE_URL } from '@/features/appShell/utils/adminPortal'
import { useConnectedAppsStore } from '@/stores/useConnectedAppsStore'
import { useUserStore } from '@/stores/useUserStore'

const REGULAR_USER_MESSAGE =
  'Audit Logging is not enabled. MIRA cannot capture Outlook, Calendar, Teams, or Office activity. Contact your Microsoft 365 administrator or support@matteroom.com.'

const ADMIN_MESSAGE =
  'Audit Logging is not enabled. MIRA cannot capture Outlook, Calendar, Teams, or Office activity. To enable Audit Logging, follow the Admin Portal guide or contact support@matteroom.com.'

function AuditLoggingNotificationBar({
  showDivider = false,
}: {
  showDivider?: boolean
}) {
  const [dismissed, setDismissed] = useState(false)

  const auditLoggingViolation = useConnectedAppsStore(
    state => state.auditLoggingViolation
  )
  const selfUser = useUserStore(state => state.selfUser)

  if (!auditLoggingViolation || dismissed) return null

  const isAdmin = selfUser?.is_admin === true

  const handleGuideClick = () => {
    window.open(AUDIT_LOG_GUIDE_URL, '_blank', 'noopener,noreferrer')
  }

  return (
    <div
      role="alert"
      className={cn(
        'flex w-full items-start justify-between gap-1 bg-[#DD352C] px-5 py-3 text-[14px] font-normal leading-5 text-white shadow-sm sm:items-center',
        showDivider && 'border-0 border-t border-solid border-white/70'
      )}
    >
      <div className="flex min-w-0 flex-1 items-start gap-2.5 sm:items-center">
        <img
          className="mt-0.5 h-5 w-5 shrink-0 sm:mt-0"
          src={INFORMATION_WHITE_ICON}
          alt=""
        />
        <span className="min-w-0 flex-1 break-words">
          <span className="font-semibold">Action Required</span>
          <span className="ml-2">
            {isAdmin ? ADMIN_MESSAGE : REGULAR_USER_MESSAGE}
          </span>
        </span>
      </div>

      {isAdmin && (
        <button
          type="button"
          className="ml-2 inline-flex h-[30px] shrink-0 cursor-pointer items-center justify-center gap-1.5 rounded-full border-0 bg-white px-3 py-[5px] text-center text-sm font-normal leading-5 text-[#333333]"
          onClick={handleGuideClick}
        >
          <span>Guide Me Through</span>
        </button>
      )}

      <button
        type="button"
        className="ml-2 inline-flex h-8 shrink-0 cursor-pointer items-center justify-center rounded-full border-0 bg-transparent p-0"
        aria-label="Close audit logging notification"
        onClick={() => setDismissed(true)}
      >
        <img className="h-4 w-4" src={CLOSE_WHITE_ICON} alt="" />
      </button>
    </div>
  )
}

export default AuditLoggingNotificationBar
